export enum ReportStatus {
  Pending = 0,
  Ready = 1,
  Error = 2,
  Deleted = 3,
}

export interface Report {
  reportId: string;
  filename: string;
  type: string;
  status: ReportStatus;
  startDate: string;
  endDate: string;
  requestedAt: number;
  createdAt: number;
}

export interface TransactionStatus {
  id: number;
  name: string;
}

export interface ReportFilters {
  startDate: string;
  endDate: string;
  statuses: TransactionStatus[];
}

export interface ReportRequest extends ReportFilters {
  userId: number;
  companyId: number;
}
